import MuiDrawer from '@mui/material/Drawer';
import { styled } from '@mui/material/styles';
import { NAV, RADIUS } from '../config-layout';

const StyleDrawer = styled(MuiDrawer, { shouldForwardProp: (prop) => prop !== 'open' })(
  ({ theme, open }) => ({
    '& .MuiDrawer-paper': {
      borderTopLeftRadius: RADIUS.BORDERRADIUS,
      borderTopRightRadius: RADIUS.BORDERRADIUS,
      padding: '14px',
      marginLeft: "20px",
      position: 'relative',
      whiteSpace: 'nowrap',
      width: NAV.WIDTH,
      backgroundColor: '#f5f4f4',
      transition: theme.transitions.create('width', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen,
      }),
      boxSizing: 'border-box',
      ...(!open && {
        overflowX: 'hidden',
        transition: theme.transitions.create('width', {
          easing: theme.transitions.easing.sharp,
          duration: theme.transitions.duration.leavingScreen,
        }),
        width: theme.spacing(7),
        [theme.breakpoints.up('sm')]: {
          width: theme.spacing(9),
        },
      }),
    },
  })
);

export default StyleDrawer;
